import { Injectable, Injector } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { IHistoryModel } from '@fi-app/history/history';
import { HistoryParameterModel } from '@fi-app/history/history-list/history-parameter.model';
import { ILightWeightObjectCollection } from '@fi-shared/models';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';

@Injectable()
export class HistoryService {
    constructor(
        private injector: Injector,
        private fiBackend: FiBackendService,
    ) {}

    getHistoryListData(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IHistoryModel>>(
            'Core/History/GetHistoryListData',
            parameter,
        );
    }

    getHistoryRecords(parameter: HistoryParameterModel) {
        return this.fiBackend.fetchDataPost<IHistoryModel[]>('Core/History/GetHistoryRecords', parameter);
    }

    getHistoryRecordsCount(parameter: HistoryParameterModel) {
        return this.fiBackend.fetchDataPost<number>('Core/History/GetHistoryRecordsCount', parameter);
    }

    getLightWeightObjectsForLocalSearch(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<ILightWeightObjectCollection>(
            'Core/History/GetLightWeightObjectsForLocalSearch',
            parameter,
        );
    }
}
